
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"330","height":"802","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M397.921 158.469L594-56H392.035L297 48 201.965-56H0l196.079 214.469L0 372.938l196.079 214.469L0 802h201.965L297 698l95.035 104H594L397.921 587.531 594 373.062 397.921 158.593v-.124zM297 477.062l-95.035-104 95.035-104 95.035 104-95.035 104z","fill":"#fff","fill-opacity":".3"}})])
          )
        }
      }
    